import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Spinner, FilterPanel } from '@gsa/afp-component-library';
import { useGetDistinctStandardItems } from '../requests/vehicle-referral';


const { FilterPanelFilterShape, FilterPanelField } = FilterPanel;

const StandardItemFilterItem = (filterKey = 'standard_item_code') => () => {
  const { setFilters, getFilterFromState } = FilterPanel.useFilterPanel();
  const filter = getFilterFromState(filterKey) || { options: [], initialized: false, key: 'standard_item_code' };
  const [filterLoading, setFilterLoading] = useState(!filter.initialized);

  const placeholderOption = {
    value: '',
    label: filter?.placeholder || '-select standard item-',
  };

  useGetDistinctStandardItems({
    skip: filter.options?.length > 1,
  })
    .then(({ data }) => {
      if (data.length === 0) return;

      const standardItemOptions = [placeholderOption].concat(data.map((standardItem) => ({
        value: standardItem.standardItemNumber,
        label: standardItem.standardItemNumber + ' - ' + standardItem.title,
      })));
      
      setFilters({
        type: 'updateOptions',
        filter: {
          ...filter,
          options: standardItemOptions,
        },
      });
    })
    .catch((error) => {
      console.error('Error fetching standard items', error);
    })
    .finally(() => {
      setFilterLoading(false);
    });

  if (filterLoading) {
    return <Spinner />;
  }

  return (
    <FilterPanelField
      key={[filter.key]}
      filter={{
        ...filter,
        type: 'select',
      }}
    />
  );
};

StandardItemFilterItem.propTypes = {
  filter: PropTypes.shape(FilterPanelFilterShape).isRequired,
};

export default StandardItemFilterItem;
